// Lightweight markdown → HTML renderer (no deps).
// Supports: headings (#/##/###), bold (**x**), italic (*x*), unordered lists (-),
// ordered lists (1.), paragraphs, hard line breaks. HTML is escaped first.
function escapeHtml(s) {
    return s
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
function inline(s) {
    let out = s;
    // bold first so ** doesn't get eaten by the italic pass
    out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    out = out.replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, "$1<em>$2</em>");
    return out;
}
/**
 * Render a small markdown subset to an HTML string. Block-level parsing is line-oriented.
 */
export function renderMarkdown(input) {
    const lines = (input ?? "").replace(/\r\n/g, "\n").split("\n");
    const out = [];
    let i = 0;
    while (i < lines.length) {
        const line = lines[i];
        // Headings
        const h = /^(#{1,3})\s+(.*)$/.exec(line);
        if (h) {
            const level = h[1].length;
            out.push(`<h${level}>${inline(escapeHtml(h[2]))}</h${level}>`);
            i++;
            continue;
        }
        // Unordered list
        if (/^\s*[-]\s+/.test(line)) {
            const items = [];
            while (i < lines.length && /^\s*[-]\s+/.test(lines[i])) {
                const m = /^\s*[-]\s+(.*)$/.exec(lines[i]);
                items.push(`<li>${inline(escapeHtml(m[1]))}</li>`);
                i++;
            }
            out.push(`<ul>${items.join("")}</ul>`);
            continue;
        }
        // Ordered list
        if (/^\s*\d+\.\s+/.test(line)) {
            const items = [];
            while (i < lines.length && /^\s*\d+\.\s+/.test(lines[i])) {
                const m = /^\s*\d+\.\s+(.*)$/.exec(lines[i]);
                items.push(`<li>${inline(escapeHtml(m[1]))}</li>`);
                i++;
            }
            out.push(`<ol>${items.join("")}</ol>`);
            continue;
        }
        // Blank line — paragraph separator
        if (line.trim() === "") {
            i++;
            continue;
        }
        // Paragraph (gather consecutive non-blank, non-block lines)
        const para = [];
        while (i < lines.length && lines[i].trim() !== "" && !/^(#{1,3})\s+/.test(lines[i]) && !/^\s*[-]\s+/.test(lines[i]) && !/^\s*\d+\.\s+/.test(lines[i])) {
            para.push(inline(escapeHtml(lines[i])));
            i++;
        }
        out.push(`<p>${para.join("<br/>")}</p>`);
    }
    return out.join("\n");
}
//# sourceMappingURL=markdown.js.map